// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InviteMembersAppeal_paper__001wm {
  width: 460px;
  max-width: 100%;
  overflow-x: hidden;
}

.InviteMembersAppeal_header__cEUO7 {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 0 24px;
}

.InviteMembersAppeal_image__wb0tH {
  max-width: 100%;
  height: 200px;
  margin: 24px auto 16px;
}

.InviteMembersAppeal_title__KpiNL {
  padding-top: 0px !important;
  padding-bottom: 16px !important;
}

.InviteMembersAppeal_content__45b8Q {
  padding: 0 24px;
}
.InviteMembersAppeal_content__45b8Q > *:last-child {
  padding: 32px 0 40px;
}

.InviteMembersAppeal_description__\\+nRCN {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #272A36;
  margin-bottom: 20px;
}

.InviteMembersAppeal_close__3WADS {
  display: inline-flex;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;
  cursor: pointer;
  width: 70px;
  height: 70px;
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
  background: transparent;
  transform: rotate(0deg);
  transition: 0.3s all;
}
.InviteMembersAppeal_close__3WADS:hover {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/components/modals/InviteMembersAppeal/InviteMembersAppeal.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,2BAAA;EACA,+BAAA;AACF;;AAEA;EACE,eAAA;AACF;AACE;EACE,oBAAA;AACJ;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EAEA,uBAAA;EACA,oBAAA;AAFF;AAIE;EACE,yBAAA;AAFJ","sourcesContent":[".paper {\n  width: 460px;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n.header {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  padding: 0 24px;\n}\n\n.image {\n  max-width: 100%;\n  height: 200px;\n  margin: 24px auto 16px;\n}\n\n.title {\n  padding-top: 0px !important;\n  padding-bottom: 16px !important;\n}\n\n.content {\n  padding: 0 24px;\n\n  & > *:last-child {\n    padding: 32px 0 40px\n  }\n}\n\n.description {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  color: #272A36;\n  margin-bottom: 20px;\n}\n\n.close {\n  display: inline-flex;\n  align-content: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  cursor: pointer;\n\n  width: 70px;\n  height: 70px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: 0;\n  background: transparent;\n\n  transform: rotate(0deg);\n  transition: 0.3s all;\n\n  &:hover {\n    transform: rotate(180deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `InviteMembersAppeal_paper__001wm`,
	"header": `InviteMembersAppeal_header__cEUO7`,
	"image": `InviteMembersAppeal_image__wb0tH`,
	"title": `InviteMembersAppeal_title__KpiNL`,
	"content": `InviteMembersAppeal_content__45b8Q`,
	"description": `InviteMembersAppeal_description__+nRCN`,
	"close": `InviteMembersAppeal_close__3WADS`
};
export default ___CSS_LOADER_EXPORT___;
